<mat-form-field appearance="outline" class="w-100" cdkOverlayOrigin #origin="cdkOverlayOrigin">
  <mat-label>{{ label }}</mat-label>
  <input #trigger matInput readonly role="combobox" aria-haspopup="dialog" aria-autocomplete="none"
         [attr.aria-expanded]="opened" [attr.aria-controls]="opened ? panelId : null"
         [value]="summary" [disabled]="disabled" placeholder="All"
         (click)="open()" (keydown)="onTriggerKey($event)" />
  <button mat-icon-button matSuffix type="button" [disabled]="disabled" [attr.aria-label]="'Choose ' + label"
          (click)="opened ? close() : open()">
    <mat-icon>{{ opened ? 'expand_less' : 'expand_more' }}</mat-icon>
  </button>
</mat-form-field>
<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="origin" [cdkConnectedOverlayOpen]="opened"
             [cdkConnectedOverlayWidth]="panelWidth" [cdkConnectedOverlayViewportMargin]="12"
             [cdkConnectedOverlayHasBackdrop]="true" cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
             (backdropClick)="close()" (detach)="close()">
  <section class="filter-options" role="dialog" aria-modal="true" [id]="panelId" [attr.aria-label]="label + ' options'"
           cdkTrapFocus [cdkTrapFocusAutoCapture]="true" (keydown)="onPanelKey($event)">
    <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
      <mat-label>Search {{ label.toLowerCase() }}</mat-label>
      <input #optionSearch matInput cdkFocusInitial [value]="query" (input)="query = $any($event.target).value" />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
    <section class="selected-options" [attr.aria-labelledby]="panelId + '-selected'">
      <div class="selection-summary">
        <h3 [id]="panelId + '-selected'" aria-live="polite">Selected ({{ selected.length }})</h3>
        <button mat-button type="button" (click)="clear()" [disabled]="!selected.length">Clear</button>
      </div>
      @if (selected.length) {
        <ul class="selected-option-list">
          @for (option of selectedOptions; track option.value) {
            <li>
              <button class="selected-option" type="button" [attr.aria-label]="'Remove ' + option.label"
                      (click)="remove(option.value)">
                <span>{{ option.label }}</span>
                <mat-icon aria-hidden="true">close</mat-icon>
              </button>
            </li>
          }
        </ul>
      } @else {
        <p class="no-selection">No options selected</p>
      }
    </section>
    @if (loading) { <p role="status">Updating options…</p> }
    @if (loadError) { <p role="status">Options unavailable</p> }
    <div class="option-list" role="group" [attr.aria-label]="label" [attr.aria-busy]="loading">
      @for (option of filteredOptions; track option.value) {
        <mat-checkbox [checked]="selected.includes(option.value)"
                      [disabled]="!selected.includes(option.value) && (loading || loadError || selected.length >= 100)"
                      (change)="toggle(option.value, $event.checked)">
          {{ option.label }} @if (option.count !== undefined) { <span class="option-count">({{ option.count }})</span> }
        </mat-checkbox>
      } @empty {
        <p class="empty-options">No matching options</p>
      }
    </div>
    @if (selected.length >= 100) { <p class="selection-limit">Up to 100 selections per filter.</p> }
    <div class="panel-actions"><button mat-button type="button" (click)="close()">Done</button></div>
  </section>
</ng-template>
